import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Btn, Field, Input } from "../components/kit";
import { Logo } from "./Landing";

export default function Invite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ password: "", confirm: "" });
  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => setInv(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return setErr("As senhas não conferem");
    try {
      localStorage.removeItem("mapia_school");
      await api.post(`/auth/invite/${token}/accept`, { password: f.password });
      await refresh();
      nav("/app");
    } catch (x) {
      setErr(errMsg(x));
    }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="invite-form">
        <Logo />
        <h1 className="font-heading text-2xl font-bold text-[#0B192C]">Ativar acesso</h1>
        {inv && <p className="text-sm text-slate-600">Olá, <b>{inv.name}</b>. Crie sua senha para acessar o MapIA da escola <b>{inv.school}</b> com o e-mail <b>{inv.email}</b>.</p>}
        {inv && (
          <>
            <Field label="Senha (mín. 8 caracteres)"><Input data-testid="invite-password-input" type="password" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></Field>
            <Field label="Confirmar senha"><Input data-testid="invite-confirm-input" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} /></Field>
            <Btn data-testid="invite-accept-button" className="w-full">Criar senha e entrar</Btn>
          </>
        )}
        {err && <div data-testid="invite-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">{err}</div>}
        {err && !inv && <Link to="/login" data-testid="invite-login-link" className="block text-sm font-semibold text-[#FF6500]">Ir para o login</Link>}
      </form>
    </div>
  );
}
